module.exports = __webpack_public_path__ + "img/cloud-node-architecture.a56094c2.jpg";